import req from './http.js'

export const apiGetAnalysisReport = (org_id, experience_id, start_at,end_at ) => req('get', `/analysis/total?org=${org_id}&experience_id=${experience_id}&start=${start_at}&end=${end_at}`)

// export const apiGetAnalysisReportSummary = (params) => req('get', '/analysis/summary', params)

export const apiGetAnalysisReportSummary = (org, container, start, end) => req('get', '/analysis/summary?org=' + org + '&container=' + container + '&start=' + start + '&end=' + end)

export const apiGetAnalysisReportBounce = (org_id, experience_id, start_at,end_at ) => req(
    'get',
    `/analysis/total/bounce?org=${org_id}&experience_id=${experience_id}&start=${start_at}&end=${end_at}`
).then(function(resp){
    return resp.data
}).catch(function(error) {
    throw error
})